export default "__VITE_ASSET__CWN2oOy5__"